import script from "./RegisterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterForm.vue?vue&type=script&setup=true&lang=js"

import "./RegisterForm.vue?vue&type=style&index=0&id=0a506498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a506498"]])

export default __exports__